<template>
  <vs-popup class="add-work-order-time-popup" id="popup" :title="isCreateMode ? 'ADD WORK ORDER TIME' : 'UPDATE WORK ORDER TIME'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-work-order-time-popup" @submit.prevent="handleSubmit(onClickSave)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <small class="label">Formulation Type</small>
                <v-select name="type" :closeOnSelect="true" v-model="form.formulation_type"
                  :options="['powder', 'liquid', 'spray dry powder', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider name="clean_time" rules="required" v-slot="{ errors }" vid="clean_time">
                <small class="label">Clean Time</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                            class="w-full" v-model="form.clean_time"
                            placeholder="H:i"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="w-full vx-col md:w-1/2 w-full">
              <ValidationProvider name="machine_time" rules="required" v-slot="{ errors }" vid="machine_time">
                <small class="label">Machine Time</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                            class="w-full" v-model="form.machine_time"
                            placeholder="H:i"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-1/2 w-full">
              <ValidationProvider name="labour_time" rules="required" v-slot="{ errors }" vid="labour_time">
                <small class="label">Labour Time</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                            class="w-full" v-model="form.labour_time"
                            placeholder="H:i"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="form.note" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-work-order-manufacturing-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="resetForm" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const SettingsRepository = RepositoryFactory.get('settings');
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      formulation_type: '',
      clean_time: '',
      machine_time: '',
      labour_time: '',
      note: ''
    },
    isCreateMode: true
  }
}

export default {
  name: 'AddNewWorkOrderTimePopUp',
  data() {
    return initialState()
  },
  components: {
    'v-select': vSelect,
    flatPickr
  },
  methods: {
    async openPopup(formulationType, id) {
      try {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        this.form.formulation_type = formulationType;
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchWorkOrderTime()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {
        this.convertAndNotifyError(error.message);
      }
    },
    async fetchWorkOrderTime() {
      await this.$vs.loading({
        container: '#create-work-order-time-popup',
        scale: 0.45
      })
      try {
        const { data } = (await SettingsRepository.getSingleWorkOrderTime(this.id)).data
        // Ensure the fields are set correctly, strip seconds from times if present
        this.form = {
          formulation_type: data.formulation_type,
          clean_time: data.clean_time ? data.clean_time.substring(0, 5) : '',
          machine_time: data.machine_time ? data.machine_time.substring(0, 5) : '',
          labour_time: data.labour_time ? data.labour_time.substring(0, 5) : '',
          note: data.note || ''
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-work-order-time-popup > .con-vs-loading')
    },
    async onClickSave() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-work-order-time-popup',
        scale: 0.45
      })
      try {
        const payload = {
          formulation_type: this.form.formulation_type,
          clean_time: this.form.clean_time,
          machine_time: this.form.machine_time,
          labour_time: this.form.labour_time,
          note: this.form.note
        }
        if (this.isCreateMode) {
          await SettingsRepository.createWorkOrderTime(payload);
          this.showSuccessMessage('Work order time added!');
        } else {
          await SettingsRepository.updateWorkOrderTime(this.id, payload);
          this.showSuccessMessage('Work order time updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-work-order-time-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-work-order-time-popup > .con-vs-loading')
    },
    resetForm() {
      this.form.clean_time = ''
      this.form.machine_time = ''
      this.form.labour_time = ''
      this.form.note = ''
      this.$refs.form.reset()
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-work-order-time-popup >>> .vs-popup {
  min-width: 40% !important;
}
</style>
